// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type ReviseBidPackageCostsMutationVariables = Types.Exact<{
  input: Types.ReviseBidPackageCostsInput;
}>;


export type ReviseBidPackageCostsMutation = { __typename?: 'Mutation', reviseBidPackageCosts: { __typename?: 'ReviseBidPackageCostsResult', bidPackage: { __typename?: 'BidPackage', id: string } } };


export const ReviseBidPackageCostsDocument = gql`
    mutation ReviseBidPackageCosts($input: ReviseBidPackageCostsInput!) {
  reviseBidPackageCosts(input: $input) {
    bidPackage {
      id
    }
  }
}
    `;
export type ReviseBidPackageCostsMutationFn = Apollo.MutationFunction<ReviseBidPackageCostsMutation, ReviseBidPackageCostsMutationVariables>;

/**
 * __useReviseBidPackageCostsMutation__
 *
 * To run a mutation, you first call `useReviseBidPackageCostsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReviseBidPackageCostsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reviseBidPackageCostsMutation, { data, loading, error }] = useReviseBidPackageCostsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReviseBidPackageCostsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ReviseBidPackageCostsMutation, ReviseBidPackageCostsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ReviseBidPackageCostsMutation, ReviseBidPackageCostsMutationVariables>(ReviseBidPackageCostsDocument, options);
      }
export type ReviseBidPackageCostsMutationHookResult = ReturnType<typeof useReviseBidPackageCostsMutation>;
export type ReviseBidPackageCostsMutationResult = Apollo.MutationResult<ReviseBidPackageCostsMutation>;
export type ReviseBidPackageCostsMutationOptions = Apollo.BaseMutationOptions<ReviseBidPackageCostsMutation, ReviseBidPackageCostsMutationVariables>;